import { render, staticRenderFns } from "./InvoiceStatus.vue?vue&type=template&id=28d60043"
import script from "./InvoiceStatus.vue?vue&type=script&lang=js"
export * from "./InvoiceStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports